var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningSign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.54821 50.5274L28.2662 7.2334C28.6288 6.55863 29.1675 5.99472 29.825 5.60164C30.4825 5.20855 31.2342 5.00098 32.0002 5.00098C32.7662 5.00098 33.518 5.20855 34.1754 5.60164C34.8329 5.99472 35.3716 6.55863 35.7342 7.2334L59.4522 50.5274C59.8193 51.1849 60.0095 51.9264 60.0042 52.6794C59.9989 53.4324 59.7983 54.1712 59.4221 54.8235C59.0458 55.4758 58.5067 56.0193 57.8575 56.4009C57.2083 56.7824 56.4712 56.989 55.7182 57.0004H8.28221C7.52925 56.989 6.79214 56.7824 6.14293 56.4009C5.49372 56.0193 4.95463 55.4758 4.57835 54.8235C4.20207 54.1712 4.00148 53.4324 3.9962 52.6794C3.99092 51.9264 4.18112 51.1849 4.54821 50.5274V50.5274Z",
    fill: "white",
    stroke: "#E2E2EA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 20V42",
    stroke: "#3A4DE9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 50C32.5523 50 33 49.5523 33 49C33 48.4477 32.5523 48 32 48C31.4477 48 31 48.4477 31 49C31 49.5523 31.4477 50 32 50Z",
    stroke: "#3A4DE9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningSign);
export default __webpack_public_path__ + "static/media/warning-sign.32db8dcd.svg";
export { ForwardRef as ReactComponent };